import { useEffect, useState } from 'react';
import axios from 'axios';
import Image from 'next/image';
import { ENDPOINTS } from '@/config/endpoints';
import Link from 'next/link';
import dynamic from 'next/dynamic';
import { FormProvider } from '@/component/shared/contactForm/formContext';
import Head from 'next/head';
import { useRouter } from 'next/router';
import MexicoForm from '@/component/shared/mexicoForm/mexicoForm';
import BreadCrumb from '@/component/shared/breadCrumb';


const ContactFormStep1 = dynamic(() => import('@/component/shared/contactForm/contactFormStep1'), {
  loading: () => <p>Loading...</p>})
const ContactFormStep2 = dynamic(() => import('@/component/shared/contactForm/contactFormStep2'), {
    loading: () => <p>Loading...</p>})


const NewsDetail = ({recentPosts,post,paraUrl}) => {
  const [showNextStep, setShowNextStep]= useState(false)
const showSteps=()=>{
    setShowNextStep(true)
  }
const showFirstStep=()=>{
    setShowNextStep(false)
  }
  const router = useRouter();
  const { locale } = router;
const pathName = process.env.URL+paraUrl;
const pathName_es = process.env.URL+`/es`+paraUrl


  const dateFormat = (publishDate) => {
    const dateString = new Date(publishDate);
    const options = { day: 'numeric', year: 'numeric', month: 'short' };
    if (typeof dateString === 'object' && dateString !== null && 'toLocaleDateString' in dateString) {
      const result = dateString.toLocaleDateString('en-US', options);
      return <span>{result}</span>
    }
  }

  const dateFormatSpanish = (publishDate) => {
    const dateString = new Date(publishDate);
    const options = { day: 'numeric', year: 'numeric', month: 'short' };
    if (typeof dateString === 'object' && dateString !== null && 'toLocaleDateString' in dateString) {
      const result = dateString.toLocaleDateString('es-MX', options);
      return <span>{result}</span>
    }
  }

  const cleanedContent = post.content.rendered ? post.content.rendered.replace(/\[vc_row[^\]]*]/g, '') // Replace [vc_row]
    .replace(/\[vc_btn[^\]]*]/g, '')
    .replace(/\[vc_column[^\]]*]/g, '') // Replace [vc_column]
    .replace(/\[vc_single_image[^\]]*]/g, '') // Replace [vc_single_image]
    .replace(/\[vc_row_inner[^\]]*]/g, '') // Replace [vc_row_inner]
    .replace(/\[vc_column_inner[^\]]*]/g, '') // Replace [vc_column_inner]
    .replace(/\[vc_empty_space[^\]]*]/g, '') // Replace [vc_empty_space]
    .replace(/\[vc_raw_html[^\]]*]\[[^\]]*]/g, '') // Replace [vc_raw_html] along with its content
    .replace(/\[\/vc_column_text\]/g, '') // Replace [/vc_column_text]
    .replace(/\[\/vc_column_inner\]/g, '') // Replace [/vc_column_inner]
    .replace(/\[\/vc_row_inner\]/g, '') // Replace [/vc_row_inner]
    .replace(/\[\/vc_column\]/g, '') // Replace [/vc_column]
    .replace(/\[\/vc_row\]/g, '') // Replace [/vc_row]
    .replace(/\[vc_widget_sidebar[^\]]*]/g, '') // Replace [vc_widget_sidebar]
    .replace(/\[vc_custom_heading[^\]]*]/g, '')
    .replace(/\[vc_raw_html[^\]]*]\[[^\]]*]/g, '') // Remove [vc_raw_html] along with its content
  .replace(/\[vc_raw_html]JTVCc21hcnRfcG9zdF9zaG93JTIwaWQlM0QlMjIxMDAwNSUyMiU1RA==\[\/vc_raw_html]/g, '') : post.content.rendered ;

  const htmlString = post.yoast_head ? post.yoast_head :'';
  // Define a regular expression to match the og:description meta tag
  const regex = /<meta\s+property="og:description"\s+content="([^"]+)"\s*\/>/;
  // Use the regex to extract the content
  const match = htmlString?.match(regex);
  // Extracted description
  const description = match ? match[1] : null;

  const truncateString = (str, maxLength) => {
    if (str.length <= maxLength) {
      return str; // No truncation needed
    }

    // Truncate the string and append an ellipsis
    const truncatedString = str.slice(0, maxLength - 3) + '...';
    return truncatedString;
  }
  const truncatedTitle = (title) => {
    const originalString = title;
    const maxLength = 60;
    return truncateString(originalString, maxLength);
  }
  const decodeHtml = (html) => {
    if (!html) return '';
    if (typeof document !== 'undefined') {
      const txt = document.createElement("textarea");
      txt.innerHTML = html;
      return txt.value;
    }
    return html
      .replace(/&#(\d+);/g, (_, dec) => String.fromCharCode(dec))
      .replace(/&#x([0-9a-fA-F]+);/g, (_, hex) => String.fromCharCode(parseInt(hex, 16)))
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&quot;/g, '"')
      .replace(/&#039;/g, "'")
      .replace(/&nbsp;/g, ' ');
  };

  return (
    <main className='mt-[100px]'>
      <Head>
        <title>{post.title.rendered}</title>
        <meta name="description" content={description} />
        {/* OpenGraph tags */}
          <meta property="og:title" content={post.title.rendered}/>
        <meta property="og:description" content={description} />
        <meta property="og:image" content={post._embedded['wp:featuredmedia'][0].source_url} />
          {locale == 'es-mx'? 
          <meta property="og:url" content={pathName_es} />
          :<meta property="og:url" content={pathName} />
        }
          {locale == 'es-mx'? 
          <link rel="canonical" href={pathName_es} />:
          <link rel="canonical" href={pathName} />
        }
      </Head>
    {post !=null &&
        <section className='py-sp-small sm:pt-2'>
          <BreadCrumb parentPage={'News'} parentSlug={'news'} page={decodeHtml(post.title.rendered)} />
          <div className='container px-3  lg:px-3 xm:px-2 pt-4'>
            <div className="flex flex-wrap">
              <div className="w-[62%] sm:pr-0 pr-[40px] md:w-full sm:w-full">
                <p className='text-sm text-[#7b7b7b] mb-1 sm:pt-2 md:pt-10'>
                  <span className='font-medium text-black'>{locale == 'es-mx'?'Publicado':'Published'} : </span>
                  {locale == 'en-in' && dateFormat(post.date)}
                  {locale == 'es-mx' && dateFormatSpanish(post.date)},
                  <span className='font-medium text-black'> {locale == 'es-mx'? 'Actualizado':'Updated'} : </span>
                  {locale == 'en-in' && dateFormat(post.modified)} {locale == 'es-mx' && dateFormatSpanish(post.modified)}</p>
                <h1 className="text-heading2 sm:text-lg text-secondary font-semibold pb-4 break-words" dangerouslySetInnerHTML={{ __html: post.title.rendered }} />
                {post._embedded && post._embedded['wp:featuredmedia'] && (
                  <Image className='w-full h-auto rounded-lg mb-2' priority
                    src={post._embedded['wp:featuredmedia'][0].source_url} alt={post.title.rendered} width={840} height={439}
                  />
                )}
                <div className='blog-content break-words' dangerouslySetInnerHTML={{ __html: cleanedContent }}></div>
              </div>
              <div className="w-[38%] md:w-full sm:w-full md:mt-4 sm:mt-4">
                <div className='lg:sticky xm:sticky lg:top-[150px] xm:top-[120px]'>
                  <div className='mb-5'>
                    {locale == 'en-in' &&
                      <FormProvider>
                        {!showNextStep ?
                      <ContactFormStep1 showStep1={showSteps} />:
                        <ContactFormStep2 showPrevStep={showFirstStep} formType="GetInTouchNew"  />
                        }
                      </FormProvider>}

                    {locale == 'es-mx' &&
                      <MexicoForm />
                    }
                  </div>
                </div>
              </div>
            </div>
            {locale == 'en-in' &&
              <div className='pt-sp-big'>
                <h3 className='text-lg text-secondary font-normal py-1'>Related Content</h3>
                    <hr className='mb-2 border-brand'/>
                {recentPosts.length > 0 && (
                  <ul className='pt-1 flex flex-wrap -mx-2'>
                    {recentPosts.map(relatedPost => (
                      <Link href={relatedPost.slug} key={relatedPost.id} className='w-[25%] md:w-[50%] sm:w-full mb-3 block px-2'>
                        <div className='border border-[#E6E6E6] min-h-[250px]'>
                          <div className='w-full'>
                            {relatedPost._embedded && relatedPost._embedded['wp:featuredmedia'] && (
                              <Image className='w-full h-auto border-b-[1px] border-[#E6E6E6]' src={relatedPost._embedded['wp:featuredmedia'][0].source_url} alt={relatedPost.title.rendered} width={256} height={139} />
                            )}
                          </div>
                          <div className='date-div ml-2 pt-2'>
                            <p className='text-xs mb-2'>{dateFormat(relatedPost.date)}</p>

                            <h4 className='text-sm text-secondary font-regular two-line-truncate' dangerouslySetInnerHTML={{ __html: truncatedTitle(relatedPost.title.rendered) }}/>

                          </div>
                        </div>
                      </Link>
                    ))}
                  </ul>
                    ) }


              </div>
            }
          </div>
        </section>
      }
    </main>
  );
};

export default NewsDetail;


export async function getServerSideProps(context) {
  // Fetch data from an API or database
  const { req,locale,res } = context;
  const paraUrl = context.resolvedUrl || null
  const paramSlug = paraUrl.replace(/^\/news\//, '');
  let postId = '';
  let postData = '';
  let recentPostData = '';

  try {
    const response = await fetch(ENDPOINTS.WORDPRESS_MAIN_API+`?_embed&slug=${paramSlug}${locale == 'es-mx'? `&lang=es`:''}`); // Replace with your WordPress API endpoint URL
    const data = await response.json();
    if (data.length > 0) {
      postId = data[0].id;
    } else{
      res.statusCode = 404;
      return{
        notFound: true,
      }
    }
  } catch (error) {
    console.error('Error:', error);
    res.statusCode = 500;
    return {
      notFound: true,
    };
  }
  if (postId) {
    try {
        const response = await fetch(ENDPOINTS.WORDPRESS_MAIN_API+`/${postId}?_embed${locale == 'es-mx'? `&lang=es`:''}`); // Replace with your WordPress API endpoint URL
      const data = await response.json();
      postData = data;

    } catch (error) {
      console.error('Error:', error);
      res.statusCode = 500;
      return {
        notFound: true,
      };
    }
    const res = await axios.get(locale == 'en-in' ? ENDPOINTS.WORDPRESS_NEWS_POST_LIST_WITH_IMAGE + `&exclude=${postId}&per_page=5&_embed}` : ENDPOINTS.WORDPRESS_NEWS_POST_LIST_WITH_IMAGE_ES + `&exclude=${postId}&per_page=5&_embed}`);
    const slicedData = res.data.slice(1, 5);
    recentPostData = slicedData;
  }

  // Return the data as props
  return {
    props: {
      post:postData,
      recentPosts:recentPostData,
      paraUrl
    },
  };
}